import { render, staticRenderFns } from "./BaseAttachmentViewer.vue?vue&type=template&id=06ad984e&scoped=true"
import script from "./BaseAttachmentViewer.vue?vue&type=script&lang=js"
export * from "./BaseAttachmentViewer.vue?vue&type=script&lang=js"
import style0 from "./BaseAttachmentViewer.vue?vue&type=style&index=0&id=06ad984e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ad984e",
  null
  
)

export default component.exports